var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { downloadAttachmentFfrAPI } from "../../services/apiCalls";
import { Link, Typography } from "@mui/material";
import { renderIcon } from "../CommonFunctions";
import PhysicalPhenamenaDataGrid from "../physicalPhenamenaDataGrid";
var handleAttachmentDownload = function (value) { return __awaiter(void 0, void 0, void 0, function () {
    var fileName, request, res, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                fileName = value === null || value === void 0 ? void 0 : value.FileName;
                if (!value) return [3 /*break*/, 2];
                request = value;
                return [4 /*yield*/, downloadAttachmentFfrAPI({
                        request: request
                    })];
            case 1:
                res = _a.sent();
                url = URL.createObjectURL(res === null || res === void 0 ? void 0 : res.data);
                window.open(url, '_blank');
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
export var PhysicalPhenamenaMobileView = [{
        type: FormItemTypes.Typography,
        name: "Parameters before repair",
        fontSize: "lg",
        fontWeight: "strong",
        children: "Parameters before repair",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.List,
        name: 'ParamsBeforeRepairData',
        columnSize: 12,
        variant: 'compact',
        value: null,
        columns: [{
                field: 'Parameter',
                flex: 1,
                renderCell: function (_ref) {
                    var row = _ref.row;
                    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                        p: 1,
                        fontWeight: 'bold',
                        fontSize: 'md'
                    }, row.Parameter, ":"));
                }
            }],
        disableCheckboxSelection: true,
        getRowHeight: function () { return 'auto'; },
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: 'section',
                columnSize: 12,
                m: 1,
                spacing: 1,
                elements: [{
                        type: FormItemTypes.Typography,
                        name: 'CheckedParams',
                        label: 'Parameters checked :',
                        columnSize: 12
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Observations',
                        label: 'Observations :',
                        columnSize: 12
                    }]
            }]
    }, {
        type: FormItemTypes.Typography,
        name: "Parameters while repair",
        fontSize: "lg",
        fontWeight: "strong",
        children: "Parameters while repair",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.List,
        name: 'ParamsAfterRepairData',
        columnSize: 12,
        variant: 'compact',
        value: null,
        columns: [{
                field: 'Parameter',
                flex: 1,
                renderCell: function (_ref2) {
                    var row = _ref2.row;
                    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                        p: 1,
                        fontWeight: 'bold',
                        fontSize: 'md'
                    }, row.Parameter, ":"));
                }
            }],
        disableCheckboxSelection: true,
        getRowHeight: function () { return 'auto'; },
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: 'section',
                columnSize: 12,
                m: 1,
                spacing: 1,
                elements: [{
                        type: FormItemTypes.Typography,
                        name: 'CheckedParams',
                        label: 'Parameters checked :',
                        columnSize: 12
                    }, {
                        type: FormItemTypes.Typography,
                        name: 'Observations',
                        label: 'Observations :',
                        columnSize: 12
                    }]
            }]
    }, {
        type: FormItemTypes.CardComponent,
        name: "header",
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                spacing: 0,
                elements: __spreadArray([], [{
                        label: 'Cause of Failure',
                        filedName: 'CauseOfFailure'
                    }, {
                        label: 'Defective part identification',
                        filedName: 'DefectivePartIdentification'
                    }].map(function (item) { return ({
                    type: FormItemTypes.Typography,
                    name: item.filedName,
                    label: item.label,
                    value: '-',
                    fontSize: 'sm',
                    fontWeight: 'medium',
                    columnSize: 12,
                    labelTypographyProps: {
                        mb: 0,
                        noWrap: true,
                        fontWeight: 'medium',
                        fontSize: 'sm'
                    },
                    containerProps: {
                        display: 'flex',
                        direction: 'row',
                        justifyContent: 'space-between'
                    },
                    valueGetter: function (formValues) { return (formValues === null || formValues === void 0 ? void 0 : formValues[item.filedName]) || '-'; }
                }); }), true)
            }]
    }, {
        type: FormItemTypes.Typography,
        name: "Attachment",
        fontSize: "lg",
        fontWeight: "strong",
        children: "Attachments",
        columnSize: 12,
        sx: {
            p: 0,
            m: 0
        }
    }, {
        type: FormItemTypes.ContainerItem,
        name: '',
        columnSize: 12,
        elements: [{
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                elements: [{
                        type: FormItemTypes.List,
                        columnSize: 12,
                        name: 'ChecksheetFilledAttachments',
                        disableCheckboxSelection: true,
                        value: null,
                        columns: [{
                                field: 'ContentType',
                                maxWidth: 50,
                                renderCell: function (_ref3) {
                                    var row = _ref3.row;
                                    return renderIcon(row === null || row === void 0 ? void 0 : row.FileName);
                                }
                            }, {
                                field: 'FileName',
                                flex: 1,
                                align: 'left',
                                renderCell: function (_ref4) {
                                    var value = _ref4.value, row = _ref4.row;
                                    return /*#__PURE__*/ React.createElement(Link, {
                                        underline: "hover",
                                        variant: "button",
                                        color: "text.primary",
                                        onClick: function () { return handleAttachmentDownload(row); }
                                    }, value);
                                }
                            }, {
                                field: 'Size',
                                width: 80,
                                renderCell: function (_ref5) {
                                    var value = _ref5.value;
                                    return /*#__PURE__*/ React.createElement(Typography, {
                                        variant: "h6",
                                        sx: {
                                            alignSelf: "flex-end"
                                        },
                                        color: "text.secondary"
                                    }, "".concat(Math.round(value / 1000), " KB"));
                                }
                            }]
                    }]
            }]
    }];
export var PhysicalPhenamena = [{
        type: FormItemTypes.ContainerItem,
        name: "table",
        columnSize: 12,
        spacing: 0,
        elements: [{
                type: FormItemTypes.Custom,
                name: "FieldFailureReportParamData",
                columnSize: 12,
                element: PhysicalPhenamenaDataGrid
            }, {
                type: FormItemTypes.CardComponent,
                name: "",
                sx: {
                    mt: 2
                },
                columnSize: 12,
                elements: [{
                        type: FormItemTypes.ContainerItem,
                        display: "flex",
                        name: "",
                        justifyContent: "space-between",
                        columnSize: 12,
                        elements: [{
                                type: FormItemTypes.Typography,
                                name: "CauseOfFailure",
                                label: "Cause of Failure:",
                                containerProps: {
                                    display: "inline-flex",
                                    justifyContent: "space-between",
                                    alignItems: "baseline",
                                    gap: 1
                                },
                                labelTypographyProps: {
                                    mb: 0,
                                    noWrap: true,
                                    fontWeight: "medium",
                                    fontSize: "sm"
                                },
                                fontWeight: "medium",
                                fontSize: "sm",
                                columnSize: 12
                            }, {
                                type: FormItemTypes.Typography,
                                name: "DefectivePartIdentification",
                                label: "Defective part identification:",
                                containerProps: {
                                    display: "inline-flex",
                                    justifyContent: "space-between",
                                    alignItems: "baseline",
                                    gap: 1
                                },
                                labelTypographyProps: {
                                    mb: 0,
                                    noWrap: true,
                                    fontWeight: "medium",
                                    fontSize: "sm"
                                },
                                fontWeight: "medium",
                                fontSize: "sm",
                                columnSize: 12
                            }]
                    }]
            }, {
                type: FormItemTypes.ContainerItem,
                name: '',
                columnSize: 12,
                elements: [{
                        type: FormItemTypes.Typography,
                        name: "title",
                        fontSize: "md",
                        fontWeight: "strong",
                        children: "Attachments",
                        columnSize: 12,
                        sx: {
                            p: 0,
                            mt: 1
                        }
                    }, {
                        type: FormItemTypes.ContainerItem,
                        name: '',
                        columnSize: 12,
                        elements: [{
                                type: FormItemTypes.List,
                                columnSize: 12,
                                name: 'ChecksheetFilledAttachments',
                                disableCheckboxSelection: true,
                                value: null,
                                columns: [{
                                        field: 'ContentType',
                                        maxWidth: 50,
                                        renderCell: function (_ref6) {
                                            var row = _ref6.row;
                                            return renderIcon(row === null || row === void 0 ? void 0 : row.FileName);
                                        }
                                    }, {
                                        field: 'FileName',
                                        flex: 1,
                                        align: 'left',
                                        renderCell: function (_ref7) {
                                            var value = _ref7.value, row = _ref7.row;
                                            return /*#__PURE__*/ React.createElement(Link, {
                                                underline: "hover",
                                                variant: "button",
                                                color: "text.primary",
                                                onClick: function () { return handleAttachmentDownload(row); }
                                            }, value);
                                        }
                                    }, {
                                        field: 'Size',
                                        width: 80,
                                        renderCell: function (_ref8) {
                                            var value = _ref8.value;
                                            return /*#__PURE__*/ React.createElement(Typography, {
                                                variant: "h6",
                                                sx: {
                                                    alignSelf: "flex-end"
                                                },
                                                color: "text.secondary"
                                            }, "".concat(Math.round(value / 1000), " KB"));
                                        }
                                    }]
                            }]
                    }]
            }]
    }];
